import { ComputedRef, InjectionKey } from 'vue';

/** Whether the current feed is a Salesforce feed for the account drawer */
export const ProvidedHasSalesforceFeed: InjectionKey<
  ComputedRef<boolean | null | undefined>
> = Symbol('ProvidedHasSalesforceFeed');
